// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'

export interface SendTextMessageVerificationCode {
  h: string
  locale?: string
}

export interface SimpleResponse {
  errorText?: string
  ok: boolean
}

/**
 * Validate SendTextMessageVerificationCode request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateSendTextMessageVerificationCode(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateSendTextMessageVerificationCode(request: SendTextMessageVerificationCode): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.h === undefined || req.h === null) {
    errors.push({
      field: 'h',
      code: 'required',
      message: 'h is required'
    })
  }
  if (typeof req.h === 'string' && req.h.length > 8192) {
    errors.push({
      field: 'h',
      code: 'too_long',
      message: 'h must not exceed 8192 characters',
      argument: '8192'
    })
  }
  if (typeof req.h === 'string' && req.h.trim() === '') {
    errors.push({
      field: 'h',
      code: 'required',
      message: 'h cannot be empty'
    })
  }

  if (typeof req.locale === 'string' && req.locale.length > 64) {
    errors.push({
      field: 'locale',
      code: 'too_long',
      message: 'locale must not exceed 64 characters',
      argument: '64'
    })
  }

  return errors
}

export const sendTextMessageVerificationCode = postEndpoint<SendTextMessageVerificationCode, SimpleResponse>('/auth/sendTextMessageVerificationCode')
